<template>
	<div>
		<el-row>
			<el-col :md="15">
				<div class="left" :style="'height:'+($store.state.width>$store.state.minwidth?$store.state.height:($store.state.width*0.8+44))+'px'">
					<div class="div-logo">
						<img src="../assets/login/logo.png" alt="" class="logo">
					</div>
					<el-carousel :height="($store.state.width>$store.state.minwidth?$store.state.height:($store.state.width*0.8+70))+'px'" :direction="$store.state.width>$store.state.minwidth?'vertical':'horizontal'" :interval="5000" @change="change">
						<el-carousel-item>
							<div class="banner-div" :style="'background-color: #1177dd;' +'height:'+($store.state.width>$store.state.minwidth?$store.state.height:($store.state.width*0.8))+'px'">
								<img src="../assets/login/banner1.png" alt="" width="100%" height="100%">
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="banner-div" :style="'background-color: #22bb78;' +'height:'+($store.state.width>$store.state.minwidth?$store.state.height:($store.state.width*0.8))+'px'">
								<img src="../assets/login/banner2.png" alt="" width="100%" height="100%">
							</div>
						</el-carousel-item>
					</el-carousel>
					<div class="left-footer" v-if="$store.state.width>$store.state.minwidth">
						<el-row class="left-footer-row">
							<el-col :span="5" class="footer-qq">
								<div class="footer-qq-div">
									<span>客服QQ</span><br>
									<span>1615689090</span>
								</div>
							</el-col>
							<el-col :span="5" class="footer-lx">
								<div class="footer-lx-div">
									<span>联系电话</span><br>
									<span>028-87972089</span>
								</div>
							</el-col>
							<el-col :span="14" class="footer-bq">
								<div>
									版权所有：<a class="link" href="http://www.farmereasy.com" target="_blank">成都市易农科技有限公司</a>&nbsp;<a class="link" href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备16005725号</a>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-col>
			<el-col :md="9" class="right" :style="'height:'+($store.state.width>$store.state.minwidth?$store.state.height:($store.state.height-$store.state.width*0.8-44))+'px'">
				<div class="right-title" v-if="$store.state.width>$store.state.minwidth">
					<a href="http://www.farmereasy.com" target="_blank">
						<img class="right-title-img" src="../assets/login/logo2.png" alt="">
						<div class="right-title-wz">易农科技官网</div>
					</a>
				</div>
				<div class="right-div">
					<div>
						<el-input class="login-in" v-model="form.name" placeholder="用户名" :size="$store.state.width<$store.state.minwidth?'small':''"></el-input>
						<el-input class="login-in" v-model="form.pwd" placeholder="密 码" type="password" @keyup.enter.native="onSubmit" :size="$store.state.width<$store.state.minwidth?'small':''"></el-input>
					</div>
					<div>
						<el-button class="login-bt" :style="'background-color: ' + color" @click="onSubmit()" :size="$store.state.width<$store.state.minwidth?'small':''" round>登 录</el-button>
						<el-button class="login-bt float-right" :style="'background-color: ' + color" @click="$router.push('/registe')" :size="$store.state.width<$store.state.minwidth?'small':''" round>注 册</el-button>
					</div>
					<div class="right-qcode" v-if="$store.state.width>$store.state.minwidth">
						<div class="right-qcode-div">
							<img class="wimg" src="../assets/login/gw.png" alt="" width="81">
							<div>微信公众号</div>
						</div>
						<div class="right-qcode-div float-right">
							<img class="wimg" src="../assets/login/app.png" alt="" width="81">
							<div>Android 版</div>
						</div>
					</div>
				</div>
				<div class="right-footer" :style="'background-color: ' + color" v-if="$store.state.width<$store.state.minwidth">
					技术支持：<a href="http://www.farmereasy.com" target="_blank">成都市易农科技有限公司</a>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name: '',
					pwd: ''
				},
				color: '#1177dd'
			}
		},
		methods: {
			onSubmit() {
				if (this.form.name == "" || this.form.pwd == "") {
					this.$message({
						message: '请输入账号密码！',
						type: "error",
						center: true,
					})
				} 
				else
				{
					let value={
						account: this.form.name,
						password: this.form.pwd,
					};
					this.login(value);
				}
			},
			change(e)
			{
				let color = ["#1177dd","#22bb78"];
				this.color = color[e];
			}
		}
	}
</script>

<style>
	.login-in .el-input__inner{
		border: none;
		padding: 0px;
	}
</style>

<style scoped>
	.left{
		position: relative;
	}
	.logo {
		position: absolute;
		margin: 13px;
		width: 344px;
		height: 45px;
		z-index: 100;
	}
	.left-footer{
		position: absolute;
		bottom: 0;
		color: white;
		width: 100%;
		z-index: 100;
	}
	.left-footer-row{
		padding: 20px 100px;
	}
	.footer-qq,.footer-lx,.footer-bq{
		padding-top: 5px;
		padding-bottom: 5px;
		text-align: center;
		font-size: 14px;
	}
	.footer-lx{
		border-left: 2px solid #fff;
	}
	.footer-lx-div{
		width: 100px;
		text-align: left;
		margin: auto;
	}
	.footer-qq{
		
	}
	.footer-qq-div{
		width: 100px;
		text-align: left;
		margin: auto;
	}
	.footer-bq{
		height: 45px;
		position: relative;
	}
	.footer-bq div{
		position: absolute;
		bottom: 0;
		margin-bottom: 5px;
	}
	.right{
		position: relative;
		min-height: 190px;
	}
	.right-title{
		position: absolute;
		right: 0;
		margin: 13px;
		font-size: 25px;
		line-height: 40px;
	}
	.right-title a{
		color: #000;
		text-decoration: none;
	}
	.right-title-img{
		width: 40px;
		height: 40px;
		position: absolute;
		top: 0px;
	}
	.right-title-wz{
		padding-left: 45px;
	}
	.right-div{
		position: absolute;
		top: 50%;
		left: 50%;
		width: 80%;
		max-width: 380px;
		margin-top: -100px;
		margin-left: -190px;
	}
	.login-bt{
		color: white;
		width: 140px;
		margin-top: 20px;
	}
	.login-bt:hover{
		color: white;
	}
	.float-right{
		float: right !important;
	}
	.login-in{
		border: none;
		border-bottom: 1px solid #dde8f2;
		margin-top: 20px;
	}
	.wimg{
		width: 70px;
	}
	.right-qcode{
		padding: 0 80px;
		margin-top: 150px;
	}
	.right-qcode-div{
		width: auto;
		float: left;
		text-align: center;
		font-size: 12px;
	}
	.right-footer{
		position: fixed;
		bottom: 0px;
		width: 100%;
		text-align: center;
		color: white;
		font-size: 10px;
		padding: 3px 0;
	}
	.right-footer a{
		color: white;
		text-decoration: none;
	}
	.link{
		text-decoration: none;
		color: white;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.logo{
			position: static;
			margin: 0;
			width: 220px;
			height: 27px;
		}
		.div-logo{
			position: absolute;
			text-align: center;
			padding-top: 15px;
			z-index: 100;
			width: 100%;
		}
		.right-div{
			left: 15%;
			width: 70%;
			margin-top: -99px;
			margin-left: 0px;
		}
		.login-bt{
			width: 100px;
		}
		.banner-div{
			padding-top: 45px;
		}
	}
</style>
